import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  line: null,
  lines: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
